import initData from 'init-data';

export default {
    list: [],
    topLevelCategories:
        initData.allCategories?.map(({ id, name, href }) => ({
            id,
            title: name,
            href
        })) || [],
    isFetching: false,
    error: null
};
